import type { RelayId } from "../../utils/relay";

type User = Readonly<{
  id: RelayId;
  account: string;
  realName: string;
  avatarPhotoSrcSet: any;
  isMember: boolean;
  role: string;
}>;

export interface BoardUserSlice {
  page: number;
  per: number;
  totalCount: number;
  joinedMemberCount: number;
  data: ReadonlyArray<User>;
}

export const emptyBoardUserSlice: BoardUserSlice = {
  page: 1,
  per: 10,
  totalCount: 0,
  joinedMemberCount: 0,
  data: [],
};
